import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import api from "../../../../services/api";
import { data } from "autoprefixer";
import { useState } from "react";

const PendingIssueSchema = z.object({
  title: z.string().min(1, "O título é obrigatório"),
  description: z.string().min(1, "A descrição é obrigatória"),
});

function CreatePendingIssuePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(PendingIssueSchema),
  });
  const [isError, setIsError] = useState(false);

  const onSubmit = async (values) => {
    try {
      setIsError(false);
      await api.post("/pending-issues", {
        order_load_id: Number(id),
        ...values,
      });
      navigate(`/cargas/${id}/detalhes`);
    } catch (error) {
      setIsError(true);
      console.log("Erro ao criar pendência: ", error);
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full"
      >
        <h1 className="text-2xl font-bold mb-6 text-gray-800">
          Criar Pendência de Carga
        </h1>

        <div className="mb-4">
          <label
            htmlFor="title"
            className="block text-gray-700 font-medium mb-2"
          >
            Título
          </label>
          <input
            id="title"
            type="text"
            {...register("title")}
            className={`w-full px-4 py-2 border rounded-md ${
              errors.title ? "border-red-500" : "border-gray-300"
            } focus:outline-none focus:ring focus:ring-blue-200`}
          />
          {errors.title && (
            <p className="text-red-500 text-sm mt-1">{errors.title.message}</p>
          )}
        </div>

        <div className="mb-4">
          <label
            htmlFor="description"
            className="block text-gray-700 font-medium mb-2"
          >
            Descrição
          </label>
          <textarea
            id="description"
            {...register("description")}
            rows="4"
            className={`w-full px-4 py-2 border rounded-md ${
              errors.description ? "border-red-500" : "border-gray-300"
            } focus:outline-none focus:ring focus:ring-blue-200`}
          ></textarea>
          {errors.description && (
            <p className="text-red-500 text-sm mt-1">
              {errors.description.message}
            </p>
          )}
        </div>
        {isError && (
          <p className="text-red-500 text-center mb-2">
            Não foi possível criar a pendência
          </p>
        )}
        <div className="flex flex-col gap-2">
          <button
            type="submit"
            className="w-full bg-orange-500 text-white font-medium py-2 px-4 rounded-md hover:bg-orange-600 transition focus:outline-none"
          >
            Criar Pendência
          </button>
          <button
            type="button"
            className="w-full bg-gray-400 text-white font-medium py-2 px-4 rounded-md hover:bg-gray-500 transition focus:outline-none"
            onClick={() => navigate(`/cargas/${id}`)}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
}
export default CreatePendingIssuePage;
